/**
 * Phase 41 Plan 41-05 Task 1 — KpiCard.
 *
 * Presentational primitive used by the v7 Personal Dashboard KPI strip.
 * Accepts a pre-aggregated value; data fetching happens upstream in the
 * KpiStrip composer (Task 3 / `useDashboardKpis`). Source layout per the
 * "Hi, Jana" screenshot Petra approved 2026-05-11.
 */
import { Card } from '../ui/Card';

export interface KpiCardProps {
  label: string;
  value: string | number;
  subLabel?: string;
  /** MKS-332 — the figure's definition, shown on hover over the label. */
  tooltip?: string;
}

export function KpiCard({ label, value, subLabel, tooltip }: KpiCardProps) {
  return (
    <Card>
      <div
        className={`text-[11px] font-semibold uppercase tracking-wider text-ms-text-muted ${
          tooltip ? 'cursor-help' : ''
        }`}
        title={tooltip}
      >
        {label}
      </div>
      <div className="text-[26px] font-bold text-ms-text-strong tabular-nums mt-1">{value}</div>
      {subLabel && <div className="text-[11px] text-ms-text-secondary mt-0.5">{subLabel}</div>}
    </Card>
  );
}
